import { Alert, BodyText, Link } from "@utilitywarehouse/hearth-react";

import { PrivacyNoticeDataTest } from "../constants";

const PrivacyError: React.FC = () => {
  return (
    <Alert
      colorScheme="warning"
      data-testid={PrivacyNoticeDataTest.ALERT_CUSTOMER}
    >
      <BodyText>
        If you are not happy for us to store these answers, we cannot currently
        offer this service to you online. Please call our Customer Support team
        at <Link href="tel:0333 777 0777">0333 777 0777</Link> to complete this
        instead.
      </BodyText>
    </Alert>
  );
};

export default PrivacyError;
